import locationAsText from './locationAsText'

export default function descriptionAsText({
    excerpt = '',
    currentUrl = '',
    location = '',
    locationLink = '',
    videoCallUrl = '',
} = {}): string {
    return [
        excerpt,
        currentUrl,
        locationAsText({
            location,
            locationLink,
        }),
        videoCallUrl,
    ]
        .filter(Boolean)
        .join('\n\n')
}
